import { styled } from '@mui/material/styles'

export const FooterContainer = styled('div')(({ theme }) => ({
  width: '100%',
  paddingTop: '10px',
  paddingBottom: '30px',
  backgroundColor: theme.palette.background.default,
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: '15px',
  display: 'inline-flex',
  flexShrink: 0,
  marginTop: 'auto',
  position: 'relative',
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 1,
}))

export const StyledUserInformationWrapper = styled('div')({
  width: '100%',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: '8px',
  display: 'flex',
  height: '18px',
})

export const StyledUserText = styled('span')(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: '10px',
  fontFamily: "'LibreFranklin', Inter, sans-serif",
  fontWeight: 500,
  lineHeight: '16px',
  wordWrap: 'break-word',
}))

export const StyledPayreadyLogo = styled('img')({
  width: '152.76px',
  height: '20px',
})

export const StyledFooterLogoWrapper = styled('div')({
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: '55px',
  display: 'flex',
})

export const StyledFooterMonitorWrapper = styled('div')({
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: '4px',
  display: 'flex',
})

export const StyledFooterLinks = styled('div')({
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: '24px',
  display: 'flex',
})

export const StyledFooterLinksWrapper = styled('div')({
  alignSelf: 'stretch',
  paddingLeft: '40px',
  paddingRight: '40px',
  justifyContent: 'space-between',
  alignItems: 'center',
  display: 'inline-flex',
})

export const StyledText = styled('span')(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: '10px',
  fontFamily: "'LibreFranklin', Inter, sans-serif",
  fontWeight: 500,
  lineHeight: '16px',
  cursor: 'pointer',
}))

export const StyledFrame = styled('div')({
  width: '16px',
  height: '16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export const StyledSvg = styled('svg')({
  width: '16px',
  height: '16px',
})

export const StyledMonitorIcon = styled('img')({
  width: '16px',
  height: '16px',
})

export const StyledLink = styled('a')(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: '10px',
  fontFamily: "'LibreFranklin', Inter, sans-serif",
  fontWeight: 500,
  lineHeight: '16px',
  cursor: 'pointer',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'none',
    opacity: 0.8,
  },
  '&:active': {
    textDecoration: 'none',
  },
  '&:visited': {
    textDecoration: 'none',
  },
}))

export const StyledBullet = styled('span')(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: '10px',
  fontFamily: "'LibreFranklin', Inter, sans-serif",
  fontWeight: 500,
  lineHeight: '16px',
}))
